export const WARNING_CARDS_COUNT = 40;
export const BLOCK_CARDS_COUNT = 45;
